"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var ReferenceNumberResolver = /** @class */ (function () {
    function ReferenceNumberResolver() {
    }
    ReferenceNumberResolver.getNextReferenceNumber = function (reportTableView) {
        return this.obtainReferences(reportTableView).length + 1;
    };
    ReferenceNumberResolver.getReferences = function (reportTableView) {
        var referenceDtos = this.obtainReferences(reportTableView);
        return referenceDtos;
    };
    ReferenceNumberResolver.recalculateReferenceNumbers = function (reportTableView) {
        var references = this.obtainReferences(reportTableView);
        if (references.length > 0) {
            var _loop_1 = function (i) {
                var keys = Array.from(references[i].referenceNumber.text.toMap().keys());
                var recountedRefNumber = new Map();
                keys.forEach(function (key) {
                    recountedRefNumber.set(+key, (i + 1).toString());
                });
                references[i].referenceNumber = new idm_report_export_service_client_js_1.MultilingualStyledTextDto(new idm_crosscutting_concepts_frontend_1.MultilingualString(recountedRefNumber), null);
            };
            for (var i = 0; i < references.length; ++i) {
                _loop_1(i);
            }
        }
    };
    ReferenceNumberResolver.obtainReferences = function (reportTableView) {
        var _this = this;
        var rowModel = reportTableView.rows;
        var columnsModel = reportTableView.columns;
        var references = [];
        if (rowModel && rowModel.rows.length !== 0) {
            rowModel.rows.forEach(function (row) {
                _this.processReferencesOfRowElements(row, references);
            });
        }
        if (columnsModel && columnsModel.children.length !== 0) {
            columnsModel.children.forEach(function (columnView) {
                _this.processReferencesOfColumnElements(columnView, references);
            });
        }
        if (references.length > 0) {
            var refNumber = references[0].referenceNumber.text;
            var currentLanguageId_1 = Array.from(refNumber.toMap().keys())[0];
            references.sort(function (ref1, ref2) {
                return ((+ref1.referenceNumber.text.getValue(currentLanguageId_1)) - (+ref2.referenceNumber.text.getValue(currentLanguageId_1)));
            });
        }
        return references;
    };
    ReferenceNumberResolver.processReferencesOfRowElements = function (rowElement, references) {
        var _this = this;
        if (rowElement.rowCategoryStyleDto && rowElement.rowCategoryStyleDto.reference) {
            references.push(rowElement.rowCategoryStyleDto.reference);
        }
        if (!rowElement.children || rowElement.children.length === 0) {
            return;
        }
        else {
            rowElement.children.forEach(function (child) {
                _this.processReferencesOfRowElements(child, references);
            });
        }
    };
    ReferenceNumberResolver.processReferencesOfColumnElements = function (columnElement, references) {
        var _this = this;
        if (columnElement.columnStyleDto && columnElement.columnStyleDto.reference) {
            references.push(columnElement.columnStyleDto.reference);
        }
        if (!columnElement.children || columnElement.children.length === 0) {
            return;
        }
        else {
            columnElement.children.forEach(function (child) {
                _this.processReferencesOfColumnElements(child, references);
            });
        }
    };
    return ReferenceNumberResolver;
}());
exports.ReferenceNumberResolver = ReferenceNumberResolver;
//# sourceMappingURL=reference-number-resolver.js.map